var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.3 40.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,4.74C1.02,8.42,.65,13.7,.65,20.17s.37,11.76,4.05,15.43c3.69,3.68,8.98,4.05,15.45,4.05s11.77-.37,15.44-4.05c3.69-3.68,4.06-8.97,4.06-15.43s-.38-11.78-4.07-15.45C31.91,1.05,26.61,.65,20.15,.65s-11.77,.42-15.45,4.09Z",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#75e8f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.45,9h-9.84c-1.85,0-3.35,1.5-3.35,3.35v3.21c-2.8,1.33-4.75,4.17-4.75,7.48,0,4.56,3.71,8.27,8.27,8.27,3.69,0,6.81-2.42,7.88-5.76h1.79c1.85,0,3.35-1.5,3.35-3.35V12.35c0-1.85-1.5-3.35-3.35-3.35Zm-9.67,21.01c-3.85,0-6.97-3.13-6.97-6.97,0-2.56,1.39-4.8,3.45-6.01v5.17c0,1.85,1.5,3.35,3.35,3.35h6.67c-1.01,2.61-3.54,4.46-6.5,4.46Zm6.86-5.76h-7.03c-1.13,0-2.05-.92-2.05-2.05v-5.76c.7-.24,1.44-.37,2.22-.37,3.85,0,6.97,3.13,6.97,6.97,0,.41-.04,.82-.11,1.21Zm4.87-2.05c0,1.13-.92,2.05-2.05,2.05h-1.5c.06-.4,.1-.8,.1-1.21,0-4.56-3.71-8.27-8.27-8.27-.77,0-1.51,.11-2.22,.31v-2.72c0-1.13,.92-2.05,2.05-2.05h9.84c1.13,0,2.05,.92,2.05,2.05v9.84Z",
    fill: "#624de3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopers);
export default __webpack_public_path__ + "static/media/developers.94811d79e4e34f708e94bf47df864758.svg";
export { ForwardRef as ReactComponent };